window.dremVars.hiddenItemDescription = false;
window.k1ScriptCatalog = {

	toggleSKU: function (elem) {
		if (document.querySelector(".fast-buy-item__discount") && document.querySelector(".good-element__discount")) {
			document.querySelector(".fast-buy-item__discount").textContent = document.querySelector(".good-element__discount").textContent;
		}

		let parent = elem.closest('.k1-sku-block-js');
		let title = parent.querySelector('.k1-sku-chosen-js');
		let list = parent.querySelector('.k1-sku-list-js');
		let grandPa;

		if (elem.closest('.good-element__sku')) {
			grandPa = elem.closest('.good-element__sku');
		} else if (elem.closest('.product-item-info-container')) {
			grandPa = elem.closest('.product-item-info-container');
		}

		if (elem.closest('.k1-sku-chosen-js')) {
			if (!title.classList.contains('opened')) {
				title.classList.add('opened');
				list.style.maxHeight = title.getAttribute('data-max-height') + 'px';
				parent.style.overflow = 'visible';

				if ( window.innerWidth < 767 ) {
					list.classList.add('opened')
					window.NoScroll.show(true);
				}
			} else {
				list.style.maxHeight = 0;
				setTimeout(() => {
					if (grandPa.querySelectorAll('.product-item-detail-info-container')) {
						grandPa.querySelectorAll('.product-item-detail-info-container').forEach(item => {
							item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
							item.querySelector('.k1-sku-block-js').style.overflow = 'hidden'

						});
					}
					if (grandPa.querySelectorAll('.good-item__sku-block')) {
						grandPa.querySelectorAll('.good-item__sku-block').forEach(item => {
							item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
							item.style.overflow = 'hidden'

						});
					}
				}, 300);
				if ( window.innerWidth < 767 ) {
					list.classList.remove('opened')
					window.NoScroll.hide();
				}
			}
			return false
		}

		if (elem.closest('.k1-sku-list-js')) {
			list.style.maxHeight = 0;
			setTimeout(() => {
				if (grandPa.querySelectorAll('.product-item-detail-info-container')) {
					grandPa.querySelectorAll('.product-item-detail-info-container').forEach(item => {
						item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
						item.querySelector('.k1-sku-block-js').style.overflow = 'hidden'
					});
				}
				if (grandPa.querySelectorAll('.good-item__sku-block')) {
					grandPa.querySelectorAll('.good-item__sku-block').forEach(item => {
						item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
						item.style.overflow = 'hidden'

					});
				}
			}, 300);

			if ( window.innerWidth < 767 ) {
				window.NoScroll.hide();
				list.classList.remove('opened')
			}
			if ( elem.closest('li') ) {
				title.innerHTML = elem.closest('li').getAttribute('data-temp-title');
				this.prepareSKU([...document.querySelectorAll('.k1-sku-block-js')]);
			}
			return false
		}


	},

	closeSKU: function (elem){
		let parent = elem.closest('.k1-sku-block-js');
		let title = parent.querySelector('.k1-sku-chosen-js');
		let list = parent.querySelector('.k1-sku-list-js');

		if (elem.closest('.good-element__sku')) {
			grandPa = elem.closest('.good-element__sku');
		} else if (elem.closest('.product-item-info-container')) {
			grandPa = elem.closest('.product-item-info-container');
		}

		if (elem.closest('.k1-sku-chosen-js')) {
			if (title.classList.contains('opened')) {
				list.style.maxHeight = 0;
				setTimeout(() => {
					if (grandPa.querySelectorAll('.product-item-detail-info-container')) {
						grandPa.querySelectorAll('.product-item-detail-info-container').forEach(item => {
							item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
							item.querySelector('.k1-sku-block-js').style.overflow = 'hidden'

						});
					}

					if (grandPa.querySelectorAll('.good-item__sku-block')) {
						grandPa.querySelectorAll('.good-item__sku-block').forEach(item => {
							item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
							item.style.overflow = 'hidden'
						});
					}
				}, 300);
			}
			if (window.innerWidth < 767) {
				window.NoScroll.hide();
			}
			return false
		}

		if (title.classList.contains('opened')){
			list.style.maxHeight = 0;
			title.classList.remove('opened')

			setTimeout(() => {
				if (grandPa.querySelectorAll('.product-item-detail-info-container')) {
					grandPa.querySelectorAll('.product-item-detail-info-container').forEach(item => {
						item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
						item.querySelector('.k1-sku-block-js').style.overflow = 'hidden'

					});
				}
				if (grandPa.querySelectorAll('.good-item__sku-block')) {
					grandPa.querySelectorAll('.good-item__sku-block').forEach(item => {
						item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
						item.style.overflow = 'hidden'

					});
				}

			}, 300);

			if (window.innerWidth < 767) {
				window.NoScroll.hide();
			}
		}

	},

	prepareSKU: function (array) {
		array.forEach((item, index) => {
			let title = item.querySelector('.k1-sku-chosen-js');
			let list = item.querySelector('.k1-sku-list-js');

			title.setAttribute('data-max-height', String(list.querySelector('ul').clientHeight));
			list.querySelectorAll('li').forEach(elem => {
				let selectedElem = list.querySelector('li.selected');

				if (![...list.querySelectorAll('li')].includes(selectedElem)) {
					list.querySelectorAll('li')[0].classList.add('selected')
				}

				if (elem.querySelector('.product-item-scu-item-text')) {
					if (elem.querySelector('.product-item-scu-item-text').textContent == "-") elem.style.display = "none";
					elem.setAttribute('data-temp-title', elem.querySelector('.product-item-scu-item-text').textContent);

					setTimeout(() => {
						if (elem.classList.contains('selected')) {
							title.innerHTML = elem.getAttribute('data-temp-title');
						}
					}, 200);
				}
			})
		});
	},

	hoverOut: function () {
		if (document.querySelectorAll('.good-item__sku-block')) {
			document.querySelectorAll('.good-item__sku-block').forEach(item => {
				item.querySelector('.k1-sku-chosen-js').classList.remove('opened');
				item.style.overflow = 'hidden'
			});
		}
	},

	setLastChild: function () {
		document.querySelectorAll('.section-goods .good-item').forEach((elem, index) => {
			if ((index + 1) % 3 == 0) elem.classList.add('last')
		})
	},

	setLastChildSearchPage: function () {
		document.querySelectorAll('.search-page .good-item').forEach((elem, index) => {
			if ((index + 1) % 4 == 0) elem.classList.add('last')
		})
	},

	setLastChildHomeGoods: function () {
		document.querySelectorAll('.home-top-goods .good-item').forEach((elem, index) => {
			if ((index + 1) % 4 == 0) elem.classList.add('last')
		})
	},

	setLastChildFavorites: function () {
		document.querySelectorAll('.favorite-page .good-item').forEach((elem, index) => {
			if ((index + 1) % 4 == 0) elem.classList.add('last')
		})
	},

	changeSKUName: function () {
		let skuList = document.querySelectorAll('.good-element__sku .product-item-scu-item-list .product-item-scu-item-text');
		skuList.forEach(elem => {
			if (elem.getAttribute('data-code') == "RAZMER" && document.querySelector('.good-element__sku').getAttribute('data-height')) {
				elem.textContent += 'x' + document.querySelector('.good-element__sku').getAttribute('data-height') + 'см';
			}

		})
	},

	modalPreviewCard: function (event) {
		event.preventDefault();
		let button = event.target;
		let modalCard = document.querySelector('.modal-catalog-preview');
		let card = button.closest('.good-item');
		let plug = document.createElement('div');
		let favoriteCard = card.querySelector('.good-item__tools .k1-favorite-js').classList.contains('k1-in-favorite');
		let compereCard = card.querySelector('.good-item__tools .k1-compare-js').classList.contains('k1-in-compare');

		document.querySelector('body').style.overflow = 'hidden';
		plug.classList.add('plug-card-js');
		card.before(plug);
		card.classList.remove('can-hover');
		modalCard.querySelector('.modal__body').append(card);
		const labels = card.querySelector(".good-item__picture--preview .good-item__top");
		const modalRatingBlock = modalCard.querySelector(".good-item__picture--modal .good-item__rating");
		modalRatingBlock.before(labels);
		if (card.querySelectorAll(".good-item__picture--modal .swiper-slide").length < 2) {
			card.querySelectorAll(".good-item__picture--modal .slider-chevron").forEach(elem => {
				elem.style.display = "none";
			})
		} else {
			card.querySelectorAll(".good-item__picture--modal .slider-chevron").forEach(elem => {
				elem.style.display = "block";
			})
		}

		if (favoriteCard) modalCard.querySelector('.card__info .k1-favorite-js').classList.add('k1-in-favorite');
		else modalCard.querySelector('.card__info .k1-favorite-js').classList.remove('k1-in-favorite');

		if (compereCard) modalCard.querySelector('.card__info .k1-compare-js').classList.add('k1-in-compare');
		else modalCard.querySelector('.card__info .k1-compare-js').classList.remove('k1-in-compare');

		modalCard.classList.add('opened');
		modalCard.style.display = 'block';
		window.k1Sliders.makeModalCardSlider();

	},

	closeModalPreviewCard: function () {
		let modalCard = document.querySelector('.modal-catalog-preview');
		if (!modalCard.classList.contains('opened')) return false;
		let item = modalCard.querySelector('.good-item');
		let favoriteCard = modalCard.querySelector('.card__info .k1-favorite-js').classList.contains('k1-in-favorite');
		let compereCard = modalCard.querySelector('.card__info  .k1-compare-js').classList.contains('k1-in-compare');

		let oldHome = document.querySelector('.section-goods__list').querySelector('.plug-card-js');
		const labels = modalCard.querySelector(".good-item__picture--modal .good-item__top");
		const modalRatingBlock = item.querySelector(".good-item__picture--preview .good-item__rating");
		modalRatingBlock.before(labels);

		if (favoriteCard) modalCard.querySelector('.good-item__tools .k1-favorite-js').classList.add('k1-in-favorite');
		else modalCard.querySelector('.good-item__tools .k1-favorite-js').classList.remove('k1-in-favorite');

		if (compereCard) modalCard.querySelector('.good-item__tools .k1-compare-js').classList.add('k1-in-compare');
		else modalCard.querySelector('.good-item__tools .k1-compare-js').classList.remove('k1-in-compare');


		document.querySelector('body').style.overflow = 'auto';
		oldHome.after(item);
		oldHome.remove();
		modalCard.style.display = 'none';
		modalCard.classList.remove('opened');
		item.classList.add('can-hover')
	},

	hideElementDescription: function (button, click = false) {
		if (window.dremVars.hiddenItemDescription) return false;
		if (click && !button) return false;
		if (button && button.classList.contains('opened')) {
			button.remove();
		}
		let elementInfo = document.querySelector('.element-main__info');
		if (!elementInfo) return false;

		let elementDescription;
		if(window.innerWidth <= 767)
			elementDescription = document.querySelector('.element-main__description-mobile .element-main__description.k1-isset');
		else
			elementDescription = document.querySelector('.element-main__description.k1-isset');

		if (document.querySelector('.element-description-show-more')) return false;
		if (elementDescription && elementDescription.clientHeight > 300) {
			let showMoreElement = document.createElement('div');
			showMoreElement.classList.add('element-description-show-more');
			showMoreElement.textContent = 'Читать еще';
			elementDescription.classList.remove('opened');
			elementDescription.append(showMoreElement);
			elementDescription.classList.add('hidden-text');
			elementDescription.style.maxHeight = elementInfo.clientHeight;
		}

		window.dremVars.hiddenItemDescription = true;
	},

	showElementDescription: function (button) {
		if (button.classList.contains('opened')) return false;
		// let elementDescription = document.querySelector('.element-main__description.k1-isset');
		let elementDescription;
		if(window.innerWidth <=767)
			elementDescription = document.querySelector('.element-main__description-mobile .element-main__description.k1-isset');
		else
			elementDescription = document.querySelector('.element-main__description.k1-isset');

		if (elementDescription) {

			if(window.innerWidth <=767){
				elementDescription.classList.add('opened');
				elementDescription.style.maxHeight = '';

			}else{
				elementDescription.style.maxHeight = 'none';
			}
			button.textContent = 'Скрыть';
			button.classList.add('opened');
			button.style.position = 'static';
		}
		// elementDescription.removeAttribute('style');

		window.dremVars.hiddenItemDescription = false;
	},

	init: function () {
		window.k1ScriptCatalog.setLastChild();
		window.k1ScriptCatalog.hideElementDescription();

		window.k1ScriptCatalog.prepareSKU([...document.querySelectorAll('.k1-sku-block-js')]);
		window.k1ScriptCatalog.setLastChild();
		window.k1ScriptCatalog.setLastChildSearchPage();
		window.k1ScriptCatalog.setLastChildHomeGoods();
		window.k1ScriptCatalog.setLastChildFavorites();
	},
};


if (document.querySelector('.good-item.can-hover')) {
	// document.querySelectorAll('.good-item.can-hover').forEach(elem => { });
	document.querySelectorAll('.good-item.can-hover .k1-sku-block-js').forEach(elem => {
		elem.addEventListener('mouseleave', function () {
			window.k1ScriptCatalog.hoverOut();
		})
	});
}

if (document.querySelector('.good-element__color')) {
	document.querySelectorAll('.good-element__color .k1-sku-block-js').forEach(elem => {
		elem.addEventListener('mouseleave', function () {
			window.k1ScriptCatalog.hoverOut();
		})
	});
}

window.addEventListener('DOMContentLoaded', function () {
	window.k1ScriptCatalog.init();

	if (document.querySelector('.good-item__sku-block')){
		document.querySelector('.good-item__sku-block').addEventListener('mouseleave', function (e) {
			if (e.target.closest('.good-item__sku-block').querySelector('.k1-sku-chosen-js.opened') ){
				window.k1ScriptCatalog.closeSKU(e.target);
			}
		})
	}
});

window.addEventListener('click', function (e) {
	if (e.target.closest('.good-item__sku-block')) window.k1ScriptCatalog.toggleSKU(e.target);
	if (e.target.closest('.good-item-button-open-modal')) window.k1ScriptCatalog.modalPreviewCard(e);
	if (e.target.closest('.element-description-show-more.opened')) window.k1ScriptCatalog.hideElementDescription(e.target, true);
	if (e.target.closest('.element-description-show-more')) window.k1ScriptCatalog.showElementDescription(e.target);
	if (e.target.closest('.modal-catalog-preview') &&
		(e.target.closest('.modal__close') ||	!e.target.closest('.modal__body'))) {
		window.k1ScriptCatalog.closeModalPreviewCard();
	}

	if (e.target.closest('.good-item__link') || e.target.closest('.good-item__name')) {
		window.k1ScriptCatalog.closeModalPreviewCard();
	}

	// if (window.innerWidth < 767)	{
	// 	if (e.target.closest('.good-element__sku-list.opened'))	window.k1ScriptCatalog.closeSKU(e.target);
	// }



});